import * as actionType from "./actionTypes";
import { createReducer, updateObject } from "../../utils/reducerUtils";
import { loadCart } from "../localStorage";

const MAX_QUANTITY = 20;

/* State shape
{
  items: [{ sku, quantity }],
  drawerOpen: bool,
}
*/
const initialState = {
  items: loadCart(),
  drawerOpen: false,
};

const addItem = (state, action) => {
  const existing = state.items.find((x) => x.sku === action.sku);
  if (existing) {
    return updateObject(state, {
      items: state.items.map((x) => (
        (x.sku === action.sku) ? { ...x, quantity: Math.min(x.quantity + action.quantity, MAX_QUANTITY) } : x
      )),
    });
  }
  return updateObject(state, {
    items: [...state.items, { sku: action.sku, quantity: action.quantity }],
  });
};

const setQuantity = (state, action) => {
  if (action.quantity < 1) {
    return removeItem(state, action);
  }
  return updateObject(state, {
    items: state.items.map((x) => (
      (x.sku === action.sku) ? { ...x, quantity: Math.min(action.quantity, MAX_QUANTITY) } : x
    )),
  });
};

const removeItem = (state, action) => (
  updateObject(state, {
    items: state.items.filter((x) => x.sku !== action.sku),
  })
);

const removeUnavailable = (state, action) => (
  updateObject(state, {
    items: state.items.filter((x) => action.availableSkus.includes(x.sku)),
  })
);

const clear = (state) => (
  updateObject(state, {
    items: [],
  })
);

const setDrawerOpen = (state, action) => (
  updateObject(state, {
    drawerOpen: action.isOpen,
  })
);

const reducer = createReducer(initialState, {
  [actionType.ADD_ITEM]: addItem,
  [actionType.SET_QUANTITY]: setQuantity,
  [actionType.REMOVE_ITEM]: removeItem,
  [actionType.REMOVE_UNAVAILABLE]: removeUnavailable,
  [actionType.CLEAR]: clear,
  [actionType.SET_DRAWER_OPEN]: setDrawerOpen,
});

export default reducer;

// SELECTORS
export const getItems = (state) => (
  state.items
);

export const getDrawerOpen = (state) => (
  state.drawerOpen
);
